// Application configuration for different environments
export interface Config {
  apiUrl: string;
  siteName: string;
  supportEmail: string;
}

// Determine if we're in production based on hostname
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

// Development configuration
const developmentConfig: Config = {
  apiUrl: 'http://localhost:4000/api/v1',
  siteName: 'The Defined CRM Support',
  supportEmail: 'support@thedefinedcrm.com'
};

// Production configuration
const productionConfig: Config = {
  apiUrl: 'https://dhs-backend-7eeabce30221.herokuapp.com/api/v1',
  siteName: 'The Defined CRM Support',
  supportEmail: 'support@thedefinedcrm.com'
};

// Export the appropriate configuration based on environment
export const config: Config = isProduction ? productionConfig : developmentConfig;

// Helper function to check environment
export const isDevelopment = () => !isProduction;
export const isProductionEnv = () => isProduction;